import { requireAuth } from "./auth";
import { addTouchEvent } from "./events";
import { addClickToBtns } from "./sound";
import { resetLangAttributeOfLeafs } from "./translate";

// Dropdown menu Trigger
function dropTrigger(e) {
  const x = document.getElementsByClassName("dropdown");
  for (const y of x) {
    if (y === e.currentTarget.parentNode && !y.classList.contains("drop-show"))
      y.classList.add("drop-show");
    else y.classList.remove("drop-show");
  }
  const z = document.getElementsByClassName("dropdown-content");
  for (const y of z) {
    if (y.parentNode.classList.contains("drop-show")) y.classList.add("show");
    else y.classList.remove("show");
  }
}

function closeDrops() {
  const dropdowns = document.getElementsByClassName("dropdown-content");
  for (const openDropdown of dropdowns) {
    if (openDropdown.classList.contains("show"))
      openDropdown.classList.remove("show");
  }
  const drops = document.getElementsByClassName("dropdown");
  for (const openDropdown of drops) {
    if (openDropdown.classList.contains("drop-show"))
      openDropdown.classList.remove("drop-show");
  }
}

// Dropdown Click outside of menu trigger
window.onclick = function (e) {
  if (!e.target.closest(".dropdown")) closeDrops();
};

export function addDropDown(
  clickableEl,
  contentList,
  right = false,
  doesRequireAuth = false,
  eventType = "click"
) {
  const parentNode = clickableEl.parentNode;
  const el = parentNode ? clickableEl.cloneNode(true) : clickableEl;

  const dropDownEl = document.createElement("div");
  dropDownEl.classList.add("dropdown");

  clickableEl.classList.add("dropbtn");
  dropDownEl.appendChild(el);

  const dropDownContentEl = document.createElement("div");
  dropDownContentEl.classList.add("dropdown-content");
  if (right) {
    dropDownContentEl.style.right = 0;
    dropDownContentEl.style.left = "auto";
  }
  dropDownEl.appendChild(dropDownContentEl);
  addContent(dropDownContentEl, contentList, eventType);
  if (doesRequireAuth) addTouchEvent(el, requireAuth(dropTrigger));
  else addTouchEvent(el, dropTrigger);
  if (parentNode) parentNode.replaceChild(dropDownEl, clickableEl);
  return dropDownEl;
}

export async function updateDropDown(
  clickableEl,
  contentList,
  eventType = "click"
) {
  const dropDownEl = clickableEl.parentNode;
  const dropDownContentEl = dropDownEl.querySelector(".dropdown-content");
  dropDownContentEl.innerHTML = "";
  addContent(dropDownContentEl, contentList, eventType);
  setTimeout(addClickToBtns, 0);
  return dropDownEl;
}

function addContent(dropDownContentEl, contentList, eventType) {
  for (const {
    innerHTML,
    text,
    callback,
    classList = [],
  } of contentList.filter((x) => x)) {
    const contentEl = document.createElement("div");
    contentEl.classList.add("text-sec", "drop-item", "ripple", ...classList);
    if (innerHTML) contentEl.innerHTML = innerHTML;
    else contentEl.textContent = text;

    resetLangAttributeOfLeafs(contentEl);

    addTouchEvent(
      contentEl,
      (e) => {
        e.stopPropagation();
        callback(e);
        closeDrops();
      },
      true,
      "listener",
      eventType
    );
    dropDownContentEl.appendChild(contentEl);
  }
}
